import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
 
import Banner from 'components/banner';
import RenderRichText from 'utils/richText/renderRichText';
import Card from 'components/card';
import ArrowButton from 'components/buttons/ArrowButton';
import Button from 'components/buttons/Main';
import ProductSection from 'components/product';
import ProductFeaturesSection from 'components/product/featuresSection';
import SideBarWidget from 'components/widgets';
import AircraftCardsSection from 'components/aircraft/AircraftCardsSection';
import ContentNavigation from 'components/navigation';
import NewSlider from 'components/carousel/newslider';
import MediaQuery from 'components/mediaQuery';

import { 
  FullWidthCardContainer, 
  FullWidthContainer, 
  FullWidthSmallCardsWithSeparatorContainer
} from 'components/grid/styled';

import { 
  StyledProductPageParagraphWrapper, 
  StyledProductSlicesWrapper,   
  StyledProductOverviewWrapper 
} from 'components/slices/styled';

// 96824 - this file incl preview changes

const Button1 = ({ cardButtonText, buttonHref, language }) => {
  return (
    <MediaQuery 
      mobileComponent={ 
        <ArrowButton 
          buttonText={cardButtonText}
          buttonHref={buttonHref}
          theme="red"
          isLink={true} 
          language={language}
        />
      }
      desktopComponent={ 
        <ArrowButton 
          buttonText={cardButtonText}
          buttonHref={buttonHref}
          theme="red"
          isLink={true}
          language={language}
        /> 
      }
      viewPort={630}

    />

  )
}

const BannerButton = ({ bannerButtonText, bannerButtonLink, language }) => {
  return (
    <Media query="(min-width: 640px)"> 
      {matches =>
      matches ? (
        <Button 
          isLink={true}
          language={language}
          size="large"
          buttonText={bannerButtonText}
          buttonHref={bannerButtonLink.url}
          margin="45px 0"
        />
      ) : null
    }
    </Media>
  )
}

const SlicesWrapper = ({ 
  slices, 
  preview, 
  language, 
  uid, 
  allAircraft, 
  allPrismicAircraftListing, 
  allPrismicWidgetData, 
  localePhoneNumber
}) => {   

  const isFR = process.env.LANG_CODE==='fr-fr' || language==='fr-fr';

  return (
    <StyledProductSlicesWrapper>
      <div className="product-container-top-half-overlay" />
      <div className="product-container-bottom-half-overlay" />
      {slices ? 
        slices.map((slice, index) => {
          const sliceType = slice.slice_type;

          return (
            <React.Fragment key={slice.id}>
              {(() => {
                switch (sliceType) {
                  case "banner_image": 

                    const bannerImageSrc = slice.primary.image.url;
                    const displayHeadingOneAsParagraph = slice.primary.display_heading1_as_paragraph
                    const textPosition = slice.primary.text_position;
                    const headingOneRichText = slice.primary.heading1.length > 0 && preview ? slice.primary.heading1 : slice.primary.heading1.raw;
                    const headingTwoRichText = slice.primary.heading2 ? slice.primary.heading2.length > 0 && preview ? slice.primary.heading2 : slice.primary.heading2.raw : [];
                    const headingThreeRichText = slice.primary.heading3 ? slice.primary.heading3.length > 0 && preview ? slice.primary.heading3 : slice.primary.heading3.raw: [];
                    const paragraphRichText = slice.primary.banner_text ? slice.primary.banner_text.length > 0 && preview ? slice.primary.banner_text : slice.primary.banner_text.raw : [];

                    const bannerButtonLink = preview && slice.primary.banner_button_link.link_type === "Any" ? null : slice.primary.banner_button_link;
                    const bannerButtonText = slice.primary.banner_button_text;
                    const isBottomBanner = slice.primary.display_banner_at_the_bottom;
                    const bannerImageSize = slice.primary.banner_image_size
                  
                    return (
                      <Banner 
                        desktopLarge={bannerImageSize === "large" ? true: false}
                        desktopMedium={bannerImageSize === "medium" ? true: false}
                        desktopSmall={bannerImageSize === "small" ? true: false}
                        isHomePage={false}
                        headingOne={headingOneRichText && <RenderRichText richTextArray={headingOneRichText} />}
                        headingTwo={headingTwoRichText && <RenderRichText richTextArray={headingTwoRichText} />}
                        headingThree={headingThreeRichText && headingThreeRichText && <RenderRichText richTextArray={headingThreeRichText} />}
                        displayHeadingOneAsParagraph={displayHeadingOneAsParagraph}
                        textPosition={textPosition}
                        bannerImageSrc={bannerImageSrc}
                        text={paragraphRichText && <RenderRichText richTextArray={paragraphRichText} />}
                        isBottomBanner={isBottomBanner}
                        buttonComponent={bannerButtonLink && (
                          <BannerButton 
                            bannerButtonText={bannerButtonText}
                            bannerButtonLink={bannerButtonLink}
                            language={language}
                          />
                        )}
                        
                      />
                  )
                  
                  case "product_overview_section":
                    const productOverviewText = preview ? slice.primary.product_overview_text : slice.primary.product_overview_text.raw;

                    return (
                      <FullWidthContainer>
                        <StyledProductOverviewWrapper>
                          <RenderRichText 
                            richTextArray={productOverviewText}
                          />
                        </StyledProductOverviewWrapper>
                      </FullWidthContainer>
                    )

                  case "main_features":
                    return (
                      <FullWidthContainer>
                        <ProductFeaturesSection listItems={slice.items} />
                      </FullWidthContainer>
                    )

                  case 'richtext': 
                    const richTextArray = preview ? slice.primary.text : slice.primary.text.raw;

                    return (
                      <FullWidthContainer>
                        <StyledProductPageParagraphWrapper>
                          <RenderRichText 
                            richTextArray={richTextArray}
                          />
                        </StyledProductPageParagraphWrapper>
                      </FullWidthContainer>
                    )

                  case 'product_card_section': 
                    return (
                      <FullWidthCardContainer marginBottom="40px">
                        {
                          slice.items.map(el => {
                            const cardButtonText = el.card_button;
                            const cardText = preview ? el.card_text : el.card_text.raw;
                            const cardTitle = el.card_title && el.card_title.raw;
                            const cardImageUrl = el.card_image.url;
                            const imagePosition = el.image_position;
                            const zoomButtonText = el.zoom_button_text;
                            const zoomOption = el.zoom_option;

                            return (
                              <Card 
                                cardText={<RenderRichText richTextArray={cardText} />}
                                headingText={null}
                                cardImageUrl={cardImageUrl}
                                hasSeperator={false}
                                desktopOneRowCard={true}
                                alignImage={imagePosition}
                                zoomOption={zoomOption}
                                zoomButton={Button}
                                zoomButtonText={zoomButtonText}
                                isJetCardProduct={uid !== "jet-card"}
                              />
                            )
                          })
                        }
                      </FullWidthCardContainer>
                    )

                  case "product_aircraft_category_section":
                    const smallCardButtonText = slice.primary.button_text;

                    return (
                      <FullWidthSmallCardsWithSeparatorContainer>
                        {
                          slice.items.map(el => {
                            const cardText = preview ? el.card_text : el.card_text.raw;
                            const cardTitle = el.card_title && preview ? el.card_title : el.card_title.raw;
                            const cardImageUrl = el.card_image.url;
                            const smallCardLink = el.card_link && el.card_link.url;

                            return (
                              <Card 
                                buttonComponent={smallCardLink && (
                                  <Button1 
                                    cardButtonText={smallCardButtonText} 
                                    buttonHref={smallCardLink} 
                                    language={language}
                                  />
                                )}
                                cardText={<RenderRichText richTextArray={cardText} />}
                                headingText={<RenderRichText richTextArray={cardTitle} />}
                                sizeSmall={true}
                                cardImageUrl={cardImageUrl}
                                hasSeperator={true}
                                desktopOneRowCard={false}
                                buttonAlign={"center"}
                                hideImageInMobile={true}
                              />
                            )
                          })
                        }
                      </FullWidthSmallCardsWithSeparatorContainer>
                  )

                  case "product_benefits_section":
                    return (
                      <FullWidthContainer>
                        <ProductSection slice={slice} uid={uid} />
                      </FullWidthContainer>
                  )

                  case "page_content_navigation":
                    return (
                      <ContentNavigation 
                        anchors={slice.items}
                        isFrench={isFR}
                      />  
                    )

                  case "anchors":
                    return (
                      <span 
                        id={slice.primary.anchor} 
                        style={{ position: 'absolute', marginTop: '-70px' }}
                      />
                    )

                  case "featured_aircraft_section": 
                    
                    let frCategory;

                    if(slice.primary.category === "Airliner") {
                      slice.primary.category = "VIP Airliner";
                    }

                    const category = slice.primary.category;

                    if(isFR) {
                      switch (category) {
                        case "Turboprop":
                          frCategory = "Turbopropulseur"; 
                          break;
                        case "Light Jet":
                          frCategory = "Jets Légers"; 
                          break;
                        case "Midsize Jet":
                          frCategory = "Jet intermédiaire / medium";
                          break;
                        case "Super Midsize Jet":
                          frCategory = "Jets Long-Courriers";
                          break;
                        case "Heavy Jet":
                          frCategory = "Jet lourd";
                          break;
                        case "Airliner":
                        case "VIP Airliner":
                          frCategory = "Avions Commerciaux";
                          break;
                      }
                    } 
                    
                    const aircraftCategoryData = allPrismicAircraftListing.find(el => el.node.data.aircraft_category2 === (!preview && isFR ? frCategory : category));
                    
                    let aircraftData;

                    if (preview) {
                      aircraftData = allAircraft.map(el => {
                        return {
                          id: el.aircraft_id,
                          cardImage: el.card_image.url,
                          aircraftUrl: el.url,
                        }
                      })

                    } else {
                      aircraftData = slice.items.map(el => {
                        return {
                          id: el.featued_aircraft.data.aircraft_id,
                          cardImage: el.featued_aircraft.document[0].data.card_image.url,
                          aircraftUrl: el.featued_aircraft.data.url,
                        }
                      })

                    }

                    return (
                      <React.Fragment>
                        <AircraftCardsSection 
                          aircraftData={aircraftData}
                          allAircraft={allAircraft}
                          category={category}
                          categoryUrl={aircraftCategoryData.node.data.url}
                          buttonUrl={aircraftCategoryData.node.data.url}
                          isCarousel={false}
                          preview={preview}
                          language={language}
                        />
                        <NewSlider 
                          length={aircraftData}
                          category={category}
                          component={
                            <AircraftCardsSection 
                              aircraftData={aircraftData} 
                              category={category}
                              isCarousel={true} 
                              categoryUrl={aircraftCategoryData.node.data.url}
                              buttonUrl={aircraftCategoryData.node.data.url}
                              className="carousel-card"
                              language={language}
                            />
                          }
                        /> 
                      </React.Fragment>  
                    )

                  case "widget": 
                    const widgetData = preview ? allPrismicWidgetData[0].data : slice.primary.widget_document.document[0].data;
                      
                    const widgetType = widgetData.widget_type;
                    const widgetButtonText = widgetData.widget_button_text;     
                    const widgetButtonLink = widgetData.widget_button_link.url;
                      
                    return (
                      <React.Fragment>
                        {uid !== "jet-card" ? 
                          <SideBarWidget 
                            pageType="product"
                            preview={preview}
                            widgetType={widgetType}
                            widgetData={widgetData} 
                            swissPhoneNumber={localePhoneNumber}
                            isFrench={isFR}
                            buttonComponent={
                              <Button 
                                className="widget-cta-button"
                                isLink={true}
                                size="large"
                                buttonText={widgetButtonText}
                                buttonHref={widgetButtonLink}
                                margin="0"
                                width="100%"
                                language={language}
                              />
                            }
                          />
                        :
                          <Media query="(min-width: 640px)">
                            {matches =>
                              matches ? null : (
                                <SideBarWidget
                                  pageType="product" 
                                  widgetType={widgetType}
                                  widgetData={widgetData} 
                                  swissPhoneNumber={localePhoneNumber}
                                  buttonComponent={
                                    <Button 
                                      className="widget-cta-button"
                                      isLink={true}
                                      size="large"
                                      buttonText={widgetButtonText}
                                      buttonHref={widgetButtonLink}
                                      margin="0"
                                      width="100%"
                                    />
                                  }
                                />
                              )
                            }
                          </Media>
                      }
                      </React.Fragment>
                    )
                  default: 
                    return <React.Fragment />
                }
              })()}
            </React.Fragment>
          )
        })
      : null}
    </StyledProductSlicesWrapper>
  )
};

SlicesWrapper.propTypes = {
  allAircraft: PropTypes.array,
  allPrismicAircraftListing: PropTypes.array,
  allPrismicWidgetData: PropTypes.array,
  language: PropTypes.string,
  localePhoneNumber: PropTypes.string,
  preview: PropTypes.bool,
  slices: PropTypes.array,
  uid: PropTypes.string,
};

BannerButton.propTypes = {
  bannerButtonLink: PropTypes.object,
  bannerButtonText: PropTypes.string,
  language: PropTypes.string,
};

Button1.propTypes = {
  buttonHref: PropTypes.string,
  cardButtonText: PropTypes.string,
  language: PropTypes.string,
};

export default SlicesWrapper;
